__turbopack_context__.v({
  "richText": "nFCXFG_richText",
});
